import { DivineGamepad } from "./DivineGamepad.js";
export const GamepadManager = {
    _gamepads: new Map(),
    addGamepad(event) {
        this._gamepads.set(event.gamepad.index, new DivineGamepad(event.gamepad));
    },
    removeGamepad(event) {
        this._gamepads.delete(event.gamepad.index);
    },
    updateGamepads() {
        for (const [index, gamepad] of this._gamepads) {
            gamepad.update();
        }
    },
};
